import { render, staticRenderFns } from "./ScanQRRecords.vue?vue&type=template&id=34c5fa47&scoped=true"
import script from "./ScanQRRecords.vue?vue&type=script&lang=js"
export * from "./ScanQRRecords.vue?vue&type=script&lang=js"
import style0 from "./ScanQRRecords.vue?vue&type=style&index=0&id=34c5fa47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5fa47",
  null
  
)

export default component.exports